// extracted by mini-css-extract-plugin
export default {"debts":"Profile_debts__eiA7D","stats":"Profile_stats__m7LOx","container":"Profile_container__uhL1p"};